import * as React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';
import {TransitionGroup, CSSTransition} from 'react-transition-group';
import {
    Icon,
    PriorityIcon,
    ToggleSwitch,
    Flex,
    Button
} from '@priority-software/priority-style-react';
import GeneratorActions from './GeneratorActions';
import GeneratorWhen from './GeneratorWhen';
import ConditionsList from './ConditionsList';
import ContainerHyperlink from './ContainerHyperlink';
import {saveContainer} from '../actions/Field';
import {createNewContainer} from '../actions/Screen';
import {
    getLocalizedText,
    texts,
    getGeneratorMsg,
    generatorMessages
} from '../../../../constants/TextConst';
@observer
export class GeneratorPanel extends Component<any, any> {
    input;

    constructor(props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleToggleChange = this.handleToggleChange.bind(this);
        this.handleHyperlinkValue = this.handleHyperlinkValue.bind(this);

        this.handleSave = this.handleSave.bind(this);
        this.handleSaveAdd = this.handleSaveAdd.bind(this);

        this.state = {
            saveError: false
        };
    }

    handleHyperlinkValue(e) {
        const {designScreen} = this.props;
        const {selected} = designScreen;

        selected.setHyperlink(e.target.value);

        this.setState({
            saveError: false
        });
    }

    handleClose() {
        const {designScreen} = this.props;
        const field = designScreen.selected;
        field.setActive(undefined);
        designScreen.setSelected(null);

        if (field.isNewContainer) {
            designScreen.collection.deleteField(field);
        }
    }

    handleSaveAdd() {
        const {designScreen} = this.props;
        const {selected} = designScreen;
        const {islink, hyperlink} = selected;

        if (islink && (!hyperlink || hyperlink === '')) {
            this.setState({
                saveError: true
            });

            return;
        }

        saveContainer(designScreen.selected, () => {
            designScreen.selected.setActive(undefined);
            designScreen.setSelected(null);
            // Open new generator panel
            createNewContainer(designScreen, '');
        });
    }

    handleSave() {
        const {designScreen} = this.props;
        const {selected} = designScreen;
        const {islink, hyperlink} = selected;

        if (islink && (!hyperlink || hyperlink === '')) {
            this.setState({
                saveError: true
            });
            return;
        }

        saveContainer(designScreen.selected, () => {
            this.handleClose();
        });
    }

    handleNameChange(e) {
        const {designScreen} = this.props;
        designScreen.selected.title = e.target.value;
    }

    handleToggleChange(e) {
        const {designScreen} = this.props;
        designScreen.selected.setActive(!designScreen.selected.active);
    }

    render() {
        const {designScreen, open} = this.props;
        const {ops, selected, exprFunc, exprPredefined, forValue, collection} = designScreen;
        const {fieldsToShow, reportsToShow} = collection;

        return (
            <TransitionGroup>
                {open && (
                    <CSSTransition classNames="generator-panel" timeout={1000}>
                        <div
                            className={`gr-panel-container ${
                                selected && selected.maxInputsInScreen === 1 && 'one'
                            }
								${selected && selected.maxInputsInScreen === 2 && 'two'}`}
                        >
                            <div className="opacity-wrapper-container">
                                <div className="header">
                                    <Icon
                                        icon={PriorityIcon.x}
                                        skin="primary"
                                        onClick={this.handleClose}
                                        componentClasses="panel-button"
                                    />
                                </div>
                                <div className="header-input-area">
                                    <div className="title-input-area">
                                        <div>
                                            {getLocalizedText(texts.newContainerPlaceholderText)}
                                        </div>
                                        {designScreen.selected && (
                                            <input
                                                className="title-input"
                                                type="text"
                                                ref={i => (this.input = i)}
                                                placeholder={getLocalizedText(
                                                    texts.newContainerPlaceholderText
                                                )}
                                                onChange={this.handleNameChange}
                                                value={designScreen.selected.title}
                                            />
                                        )}
                                    </div>
                                    <div className="active-toggle-area">
                                        {selected && (
                                            <span>
                                                {getGeneratorMsg(
                                                    generatorMessages.toggleActiveText
                                                )}
                                            </span>
                                        )}
                                        <div className="toggle">
                                            {selected && (
                                                <label className="switch">
                                                    <ToggleSwitch
                                                        checked={selected.active}
                                                        onChange={this.handleToggleChange}
                                                    />
                                                </label>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <ContainerHyperlink
                                    handleHyperlinkValue={this.handleHyperlinkValue}
                                    saveError={this.state.saveError}
                                    designScreen={designScreen}
                                    handleHideError={() => {
                                        this.setState({saveError: false});
                                    }}
                                />
                                {selected && selected.containerDataReceived && (
                                    <GeneratorActions
                                        sysBasicLang={designScreen.sysBasicLang}
                                        sysCurrLang={
                                            designScreen.sysCurrLang
                                        } /*0-hebrew 1-english*/
                                        field={selected}
                                        reportsToShow={reportsToShow}
                                    />
                                )}
                                {selected && (
                                    <ConditionsList
                                        ops={ops}
                                        forValue={forValue}
                                        fieldsToShow={fieldsToShow}
                                        reportsToShow={reportsToShow}
                                        field={selected}
                                        conds={selected.conds}
                                        exprFunc={exprFunc}
                                        exprPredefined={exprPredefined}
                                        sysBasicLang={designScreen.sysBasicLang}
                                        sysCurrLang={designScreen.sysCurrLang}
                                    />
                                )}
                                {selected && <GeneratorWhen field={selected} />}
                            </div>
                            <Flex justifyContent="space-around">
                                <Button
                                    onClick={this.handleSave}
                                    skin="text"
                                    size="large"
                                    componentClasses="gr-panel-save-btn"
                                >
                                    {getLocalizedText(texts.save)}
                                </Button>
                                <Button
                                    onClick={this.handleSaveAdd}
                                    skin="primary"
                                    size="large"
                                    componentClasses="gr-panel-save-and-add-btn"
                                >
                                    {getLocalizedText(texts.btnSaveAndAddContainerText)}
                                </Button>
                            </Flex>
                        </div>
                    </CSSTransition>
                )}
            </TransitionGroup>
        );
    }
}

export default GeneratorPanel;
